<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="table-bar" style="margin-bottom: 0" v-if="showOpt">
      <el-form
          :inline="true"
          :model="queryForm"
          @keyup.enter.native="getDataList()"
          ref="queryForm"
          class="query-form"
      >
        <el-form-item prop="sellerName" label="外销合同号：">
          <el-input
              v-model="queryForm.orderCode"
              size="mini"
              clearable
              type="text"
              placeholder="请输入外销合同号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="storeName" label="仓库：">
          <el-input
              v-model="queryForm.storeName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入仓库名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="productName" label="品名：">
          <el-input
              v-model="queryForm.productName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入品番号/品名/颜色/规格"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reload" size="mini"
          >查询
          </el-button
          >
          <el-button @click="reset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <vxe-toolbar ref="xToolbar" v-if="showOpt" custom>
      <template v-slot:buttons>
        <el-button type="primary" size="mini" @click="go2Save(1)" v-if="productType==='原料'">{{ optName }}入库</el-button>
        <el-button type="primary" size="mini" @click="go2Save(-1)">{{ optName }}出库</el-button>
<!--        <el-button type="warning" size="mini" @click="checkInImport"  v-if="productType==='原料'">批量入库</el-button>-->
<!--        <el-button type="warning" v-if="$hasPermission('store:receipt')" size="mini" @click="receiptImport">发票导入-->
<!--        </el-button>-->
        <!--        <el-button type="warning" size="mini" @click="showTransferDialog()">库存调配</el-button>-->
        <el-button type="warning" size="mini" @click="showInitUploader()">原始库存导入</el-button>
        <el-button v-if="productType==='原料'" type="warning" size="mini"
                   @click="$router.push(`/store/material/settle`)">用料结算
        </el-button>

      </template>
    </vxe-toolbar>
    <vxe-table
        align="center"
        :id="tableConfig.id"
        :ref="tableConfig.tableName"
        show-overflow
        row-id="id"
        :height="tableConfig.height"
        :loading="tableData.loading"
        :data="tableData.dataList"
        :cell-style="cellStyleHandler"
        :custom-config="{ storage: true, checkMethod: checkColumnHandler }"
        @resizable-change="resizableChangeEvent"
    >
      <vxe-column type="checkbox" width="50" fixed="left"></vxe-column>
      <vxe-column type="seq" title="行号" width="50"></vxe-column>
      <vxe-column
          field="agreementCode"
          title="合同编号"
          min-width="160"
          :formatter="companyNameFormatter"
      ></vxe-column>
      <vxe-column
          field="storageName"
          title="仓库名称"
          :formatter="companyNameFormatter"
          min-width="160"
      ></vxe-column>
      <vxe-column field="code" title="品番号" min-width="90" v-if="productType==='产品'"></vxe-column>
      <vxe-column field="skuCode" title="SKU" min-width="90" v-if="productType==='产品'"></vxe-column>
      <vxe-column field="name" title="品名" min-width="90"></vxe-column>
      <vxe-column field="color" title="颜色" min-width="90"></vxe-column>
      <vxe-column field="size" title="规格" min-width="90"></vxe-column>
      <vxe-column field="attr1" title="幅宽" min-width="90" v-if="productType==='原料'"></vxe-column>
      <vxe-column field="attr2" title="克重" min-width="90" v-if="productType==='原料'"></vxe-column>
      <vxe-column field="nameZh" title="中文品名" min-width="90" v-if="productType==='产品'"></vxe-column>
      <vxe-column field="count" title="库存数量" min-width="90" fixed="right">
        <template #default="{ row }">
          <el-tag :type="row.count > 0 ? 'success' : 'danger'">{{ row.count }}</el-tag>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
        :loading="tableData.loading"
        :current-page="tableData.currentPage"
        :page-size="pagerConfig.pageSize"
        :total="tableData.total"
        :layouts="pagerConfig.layouts"
        @page-change="vxePageChanger"
    >
    </vxe-pager>
    <common-upload
        ref="commonUpload"
        @success="uploadSuccessHandler"
        :uploadUrl="uploadData.uploadUrl"
        :templateUrl="uploadData.templateUrl"
        :title="uploadData.title"
        :data="uploadData.data"
        version="v2"
    ></common-upload>
    <!--    <TransferDialog ref="transferDialog" :product-type="productType" @change="getDataList"></TransferDialog>-->
  </el-card>
</template>
<script>

import VxeTable from '@/mixins/vxe-table'

export default {
  mixins: [VxeTable],
  components: {},
  props: {
    productType: '',
    showOpt: {
      type: Boolean,
      default: true
    },
    orderId: {
      type: String,
      default: ''
    },
    autoLoad: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      uploadData: {
        uploadUrl: '',
        templateUrl: '',
        title: '',
        data: {}
      },
      tableConfig: {
        queryUrl: '/store/page',
        autoLoad: false,
        otherHeight: 55,
        audio: this.autoLoad
      },
      queryForm: {
        productType: '',
        productName: '',
        orderCode: '',
        storeName: '',
      },
    }
  },
  watch: {
    orderId: {
      handler: function (newVal) {
        if (!newVal) {
          return
        }
        this.queryForm.orderId = newVal
        this.reload()
      },
      immediate: true
    },
    productType: {
      handler: function (newVal) {
        this.queryForm.productType = newVal
        if (this.autoLoad) {
          this.reload()
        }
      },
      immediate: true
    }
  },
  computed: {
    optName () {
      if (this.productType == '产品') {
        return '成品'
      } else if (this.productType == '原料') {
        return '原料'
      }
    }
  },
  methods: {
    showInitUploader () {
      this.uploadData.title = '原始库存导入'
      this.uploadData.data = {
        pType: this.productType
      }
      this.uploadData.uploadUrl = '/erp/store/init/import'
      if (this.productType == '产品') {
        this.uploadData.templateUrl = '/static/template/成品库初始化模板.xlsx'
      } else if (this.productType == '原料') {
        this.uploadData.templateUrl = '/static/template/原料库初始化模板.xlsx'
      }
      this.$nextTick(() => {
        this.$refs.commonUpload.init()
      })

    },
    // showTransferDialog () {
    //   let rows = this.$refs[this.tableConfig.tableName].getCheckboxRecords()
    //   if (rows.length === 0) {
    //     return this.$message.error('请选择要调仓的成品或原辅料')
    //   }
    //   const data = this.$clone(rows)
    //   let outStorageId = ''
    //   let validRes = true
    //   data.forEach((item) => {
    //     item.count = 0
    //     if (outStorageId == '') {
    //       outStorageId = item.storageId
    //     }
    //     if (outStorageId !== item.storageId) {
    //       validRes = false
    //     }
    //   })
    //   if (!validRes) {
    //     return this.$message.error('调出仓库不一致,请重新选择')
    //   }
    //   this.$refs.transferDialog.dataForm.checkOutStorageId = outStorageId
    //   this.$refs.transferDialog.dataForm.detailList = data
    //   this.$refs.transferDialog.init()
    // },
    //发票导入
    // receiptImport () {
    //   this.uploadData.data = {
    //     productType: this.productType
    //   }
    //   this.uploadData.title = `${this.productType}发票导入`
    //   if (this.productType == '原料') {
    //     this.uploadData.uploadUrl = '/erp/store/material/import/receipt'
    //     this.uploadData.templateUrl = '/static/template/采购入库导入模板.xlsx'
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.commonUpload.init()
    //   })
    // },
    //原料批量入库
    // checkInImport () {
    //   this.uploadData.data = {
    //     productType: this.productType
    //   }
    //   this.uploadData.title = `${this.productType}批量入库`
    //   if (this.productType == '原料') {
    //     this.uploadData.uploadUrl = '/erp/store/material/import/checkin'
    //     this.uploadData.templateUrl = '/static/template/采购入库导入模板.xlsx'
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.commonUpload.init()
    //   })
    // },
    go2Save (type) {
      let productType
      if (this.productType == '产品') {
        productType = 1
      } else if (this.productType == '原料') {
        productType = 2
      }
      this.$router.push(`/store-manager/save?type=${type}&productType=${productType}`)
    },
    uploadSuccessHandler () {
      this.reload()
    }
  },
}
</script>

<style scoped></style>
